import UXEvents from '@enums/ux-events';

export default [
    {
        key: UXEvents.campaignDeleted,
        actions: ['campaigns/setSelectedCampaignId', 'notifications/fetchOpenNotifications'],
    },
];
